// import { API_BASE } from "../config/api";
// import { useState } from "react";
// import Editor from "@monaco-editor/react";
// import Navbar from "../components/Navbar";

// export default function Compiler() {
//   const [language, setLanguage] = useState("python");
//   const [code, setCode] = useState(`# Python example
// name = input()
// print("Hello", name)`);
//   const [input, setInput] = useState("");
//   const [output, setOutput] = useState("Output will appear here...");
//   const [loading, setLoading] = useState(false);

//   // 🔥 input hint toggle
//   const [showHint, setShowHint] = useState(true);

//   // ✅ language change handler (UNCHANGED)
//   const handleLanguageChange = (lang) => {
//     setLanguage(lang);
//     setInput("");
//     setOutput("Output will appear here...");

//     if (lang === "python") {
//       setCode(`# Python example
// name = input()
// print("Hello", name)`);
//     } else if (lang === "java") {
//       setCode(`import java.util.*;

// public class Main {
//   public static void main(String[] args) {
//     Scanner sc = new Scanner(System.in);
//     String name = sc.nextLine();
//     System.out.println("Hello " + name);
//   }
// }`);
//     } else if (lang === "cpp") {
//       setCode(`#include <bits/stdc++.h>
// using namespace std;

// int main() {
//     string name;
//     getline(cin, name);
//     cout << "Hello " << name;
//     return 0;
// }`);
//     } else if (lang === "bash") {
//       setCode(`# Bash support coming soon`);
//       setOutput("🚧 Bash support coming soon");
//     }
//   };

//   // ✅ runCode (UNCHANGED)
//   const runCode = async () => {
//     if (language === "bash") {
//       setOutput("🚧 Bash support coming soon");
//       return;
//     }

//     if (language === "python" && code.includes("input(") && !input.trim()) {
//       setOutput("⚠️ Python program requires input.");
//       return;
//     }

//     if (language === "java" && code.includes("Scanner") && !input.trim()) {
//       setOutput("⚠️ Java program requires input.");
//       return;
//     }

//     setLoading(true);
//     setOutput("Running... ⏳");

//     try {
//       const res = await fetch(`${API_BASE}/run`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ language, code, input }),
//       });

//       const data = await res.json();
//       setOutput(data.output || "No output received");
//     } catch {
//       setOutput("❌ Backend not reachable");
//     }

//     setLoading(false);
//   };

//   return (
//     <>
//       <Navbar />

//       <div className="bg-gray-950 min-h-screen text-white px-6 py-5">

//         {/* ================= TOP BAR ================= */}
//         <div className="flex justify-between items-center mb-4">
//           <div className="flex items-center gap-3">
//             <span className="text-lg font-bold">Online Compiler</span>
//             <span className="text-xs bg-blue-600 px-2 py-1 rounded">
//               {language.toUpperCase()}
//             </span>
//           </div>

//           <div className="flex gap-3">
//             <select
//               className="bg-gray-800 px-4 py-2 rounded-lg border border-gray-700 focus:outline-none"
//               value={language}
//               onChange={(e) => handleLanguageChange(e.target.value)}
//             >
//               <option value="python">Python</option>
//               <option value="java">Java</option>
//               <option value="cpp">C++</option>
//               <option value="bash">Bash</option>
//             </select>

//             <button
//               className="bg-gray-700 px-4 py-2 rounded-lg hover:bg-gray-600"
//               onClick={() => setOutput("")}
//             >
//               Clear
//             </button>

//             <button
//               disabled={loading || language === "bash"}
//               className="bg-green-600 hover:bg-green-700 px-6 py-2 rounded-lg font-semibold disabled:opacity-50"
//               onClick={runCode}
//             >
//               ▶ {loading ? "Running..." : "Run"}
//             </button>
//           </div>
//         </div>

//         {/* ================= MAIN GRID ================= */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">

//           {/* ================= EDITOR ================= */}
//           <div className="lg:col-span-2 border border-gray-800 rounded-xl overflow-hidden">
//             <div className="bg-gray-900 px-4 py-2 text-sm text-gray-400 border-b border-gray-800">
//               Code Editor
//             </div>
//             <Editor
//               height="65vh"
//               language={language === "cpp" ? "cpp" : language}
//               theme="vs-dark"
//               value={code}
//               onChange={(value) => setCode(value || "")}
//               options={{
//                 fontSize: 14,
//                 tabSize: 4,
//                 insertSpaces: true,
//                 autoIndent: "advanced",
//                 formatOnType: true,
//                 formatOnPaste: true,
//                 minimap: { enabled: false },
//                 scrollBeyondLastLine: false,
//                 autoClosingBrackets: "always",
//                 autoClosingQuotes: "always",
//               }}
//             />
//           </div>

//           {/* ================= INPUT / OUTPUT ================= */}
//           <div className="flex flex-col gap-4">

//             {/* INPUT */}
//             <div className="bg-gray-900 border border-gray-800 rounded-xl p-4">
//               <div className="flex justify-between items-center mb-2">
//                 <p className="text-sm text-gray-400">Input (stdin)</p>
//                 <button
//                   onClick={() => setShowHint(!showHint)}
//                   className="text-xs text-blue-400 hover:underline"
//                 >
//                   {showHint ? "Hide hint" : "Show hint"}
//                 </button>
//               </div>

//               {showHint && (
//                 <div className="mb-3 text-xs bg-gray-800 border border-gray-700 rounded-lg p-3 text-gray-300">
//                   <p className="font-semibold mb-1">💡 Input Hint</p>
//                   <ul className="list-disc list-inside space-y-1">
//                     <li>Space separated input → <code>1 2 3</code></li>
//                     <li>New line input:</li>
//                     <pre className="bg-black rounded p-2 mt-1 text-green-400">
// {`1
// 2
// 3`}
//                     </pre>
//                     <li>Works for Python, Java & C++</li>
//                   </ul>
//                 </div>
//               )}

//               <textarea
//                 value={input}
//                 onChange={(e) => setInput(e.target.value)}
//                 className="w-full bg-gray-800 border border-gray-700 rounded-lg p-3 text-sm focus:outline-none"
//                 rows="4"
//                 placeholder="Enter input..."
//               />
//             </div>

//             {/* OUTPUT */}
//             <div className="flex-1 bg-black border border-gray-800 rounded-xl p-4 overflow-auto">
//               <p className="text-sm text-gray-400 mb-2">Output</p>
//               <pre className="text-green-400 whitespace-pre-wrap">
//                 {output}
//               </pre>
//             </div>

//           </div>
//         </div>

//       </div>
//     </>
//   );
// }
export default function Compiler() {
  return (
    <div className="min-h-screen flex items-center justify-center
      bg-gradient-to-br from-black via-gray-950 to-black text-white">

      <div className="text-center max-w-md px-6">
        {/* Animated icon */}
        <div className="text-6xl mb-6 animate-bounce">🛠️</div>

        <h1 className="text-4xl font-extrabold mb-4">
          Under Maintenance
        </h1>

        <p className="text-gray-400 mb-6">
          Our compiler is temporarily unavailable due to server maintenance.
          We’re working hard to bring it back online.
        </p>

        {/* Animated loader */}
        <div className="flex justify-center gap-2 mb-6">
          <span className="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></span>
          <span className="w-3 h-3 bg-blue-500 rounded-full animate-pulse delay-150"></span>
          <span className="w-3 h-3 bg-blue-500 rounded-full animate-pulse delay-300"></span>
        </div>

        <p className="text-sm text-gray-500 italic">
          Please check back again soon 🚀
        </p>
      </div>
    </div>
  );
}

